import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface CurrencyOption {
  label: string
  value: string
}

export const createCurrencyFilter = (currencies: CurrencyOption[]): FilterDefinition => ({
  label: i18n.t('finance.invoices.list.fields.currency'),
  type: 'in',
  options: {
    options: currencies,
  },
})
